import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

const STATUS_COLORS = {
  draft: "bg-slate-100 text-slate-600", sent: "bg-blue-100 text-blue-700", approved: "bg-green-100 text-green-700",
  rejected: "bg-red-100 text-red-700", unpaid: "bg-amber-100 text-amber-700", partially_paid: "bg-blue-100 text-blue-700",
  paid: "bg-green-100 text-green-700", overdue: "bg-red-100 text-red-700", cancelled: "bg-slate-100 text-slate-500",
};

export function StatusBadge({ status }) {
  return <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${STATUS_COLORS[status] || "bg-slate-100 text-slate-600"}`}>{(status || "").replace("_", " ")}</span>;
}

const inp = "h-9 px-2 rounded-lg border border-input text-sm focus:outline-none focus:ring-2 focus:ring-electric";

export function ItemsEditor({ items, setItems }) {
  const upd = (i, k, v) => setItems(items.map((it, idx) => idx === i ? { ...it, [k]: v } : it));
  const add = () => setItems([...items, { name: "", description: "", quantity: 1, unitPrice: 0 }]);
  const rm = (i) => setItems(items.filter((_, idx) => idx !== i));
  return (
    <div className="space-y-2">
      {items.map((it, i) => (
        <div key={i} className="flex gap-2 items-start" data-testid={`line-item-${i}`}>
          <input className={`${inp} flex-1`} placeholder="Item name" value={it.name} onChange={e => upd(i, "name", e.target.value)} data-testid={`item-name-${i}`} />
          <input className={`${inp} w-16`} type="number" placeholder="Qty" value={it.quantity} onChange={e => upd(i, "quantity", Number(e.target.value))} data-testid={`item-qty-${i}`} />
          <input className={`${inp} w-24`} type="number" placeholder="Price" value={it.unitPrice} onChange={e => upd(i, "unitPrice", Number(e.target.value))} data-testid={`item-price-${i}`} />
          <button type="button" onClick={() => rm(i)} className="p-2 text-red-500 hover:bg-red-50 rounded"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} className="gap-1.5" data-testid="add-item-btn"><Plus className="h-4 w-4" /> Add item</Button>
    </div>
  );
}
